export default {
  background: '#eeeff3',
  black: '#000000',
  white: '#ffffff',
  gray: '#808080',
  lightGray: '#D9D9D9',
  lightestGray: '#FAFAFA',
  darkGray: '#f9f9f9',
  darkestGray: '#f0f0f0',
  accent: '#3FCFC6',
  primary: '#1890ff',
  alert: '#FF4D4F',
  success: '#63D14F',
  greenBadge: '#52c41a',
  blackAlpha: (opacity: number) => `rgba(0, 0, 0, ${opacity})`,
};
